<template>
  <div class="drop--detail__container">
    <ContextTitle :title="$t('drops.selected_unit')" class="drop--detail__title"/>
    <!-- <ContextItemEditableValue
      :iconTooltip="'Custom Name'"
      :icon="'fas fa-file-signature'"
      :attribute="''"
      :eventName="'click'"
      :valuesObject="{ ...computeCustomName }"
      @save-emitted="updateCustomName"
      :savedByEnter="true"
    /> -->
    <ContextItemEditableInput
      :icon="'fas fa-file-signature'"
      :iconTooltip="$t('drops.custom_name')"
      :eventName="'click'"
      :value="selectedUnit.ref"
      :emptyValue="`${$t('drops.add_custom_name')}`"
      @save-emitted="updateCustomName"
      :savedByEnter="true"
    />
    <ContextItemAutoComplete
      :eventName="'click'"
      :iconTooltip="$t('drops.status')"
      :icon="'far fa-clipboard'"
      :label="$t('drops.status') + ':'"
      :value="computeStatus"
      @autocompleteSave="changeStatus"
      :list="[ { text: $t('orders.OnTheWay'), status: 'OnTheWay', id: 1}, { text: $t('orders.Delivered'), status: 'Delivered', id: 7}, { text: $t('orders.ReadyToPickup'), status: 'ReadyToPickup', id: 8}, { text: $t('orders.NotReady'), status: 'NotReady', id: 9}]"
    />
    <ContextItemNoEditable
      :iconTooltip="$t('drops.unit_weight')"
      :icon="'fas fa-box'"
      :attribute="computeTotalWeight.attribute"
      :value="computeTotalWeight.value"
      :isCopyable="false"
    />
    <!-- <ContextInfo class="drop--detail__info" :isLoading="computeTotalWeight.isLoading" :icon="'fas fa-box'" :attribute="computeTotalWeight.attribute" :value="computeTotalWeight.value"/> -->
    <ContextItemEditableValue
      :iconTooltip="$t('drops.packaging_weight')"
      :icon="'fas fa-box-open'"
      :attribute="$t('drops.packaging_weight_is')"
      :eventName="'click'"
      :valuesObject="{ weight: computePackagingWeight, text: computePackagingWeight + ' kg', measurement: 'kg' }"
      :savedByEnter="true"
      @save-emitted="updatePackagingWeight"
      :isMaxContentFlex="true"
    />
    <ContextItemNoEditable
      :iconTooltip="$t('drops.unit_volume')"
      :icon="'fas fa-arrows-alt'"
      :attribute="computeTotalVolume.attribute"
      :value="computeTotalVolume.value"
      :isCopyable="false"
    />
    <!-- <ContextInfo class="drop--detail__info" :icon="'fas fa-arrows-alt'" :isLoading="computeTotalVolume.isLoading" :attribute="computeTotalVolume.attribute" :value="computeTotalVolume.value"/> -->
    <ContextItemEditableValue
      :iconTooltip="$t('drops.dimensions')"
      :icon="'fas fa-box-open'"
      :attribute="computeDimensions.attribute"
      :eventName="'click'"
      :valuesObject="{ length: selectedUnit.dimensions.length, width: selectedUnit.dimensions.width, height: selectedUnit.dimensions.height,  text: computeDimensions.value + ' cm', measurement: 'cm', splitter: 'x'}"
      @save-emitted="updateCustomDimensions"
      @input-emitted="updateRecommendedDimensions"
      :extraActions="isRecommended ? [{ icon: 'fas fa-stethoscope', tooltip: 'Fixing Dimensions', callback: recommendEdit }] : null"
      :savedByEnter="true"
    />
    <ContextInfo :iconTooltip="$t('drops.orders_and_items')" class="drop--detail__info" :icon="'fas fa-file-invoice'" :isLoading="false" :customText="computeOrder"/>
  </div>
</template>

<script>
import { dropHelpers } from '@/_helpers'
import { mapActions } from 'vuex'
import ContextInfo from '@/components/drops/detail/ContextInfo.vue'
import ContextTitle from '@/components/drops/detail/ContextTitle.vue'
import ContextItemAutoComplete from '@/components/wrld/generic/ContextItemAutoComplete'
import ContextItemEditableValue from '@/components/wrld/generic/ContextItemEditableValue'
import ContextItemNoEditable from '@/components/wrld/generic/ContextItemNoEditable'
import ContextItemEditableInput from '@/components/wrld/generic/ContextItemEditableInput'
import Pallet from '@/plugins/pallet-recommendation.js'
export default {
  name: 'DropContextSelectedUnits',
  components: {
    ContextInfo,
    ContextTitle,
    ContextItemAutoComplete,
    ContextItemEditableValue,
    ContextItemNoEditable,
    ContextItemEditableInput
  },
  props: {
    selectedUnit: Object
  },
  data () {
    return {
      customWeight: 0,
      customDimensions: {
        width: null,
        length: null,
        height: null
      },
      customName: null,
      localCustomName: null
    }
  },
  methods: {
    ...mapActions({
      setCustomName: 'setCustomName',
      setCustomWeight: 'setCustomWeight',
      setCustomDimensions: 'setCustomDimensions',
      setCustomStatus: 'setCustomStatus'
    }),
    initializePackagingWeight () {
      this.customWeight = this.computePackagingWeight
    },
    updatePackagingWeight (valuesArray) {
      let weightValue = valuesArray[0].value
      let weightNumber = Number(weightValue)
      weightNumber = isNaN(weightNumber) ? 0 : weightNumber
      // Packaging weight in Grams for BE
      const weight = (this.selectedUnit.weight - this.selectedUnit.packagingWeight) + (weightNumber * 1000)
      this.setCustomWeight({ id: this.selectedUnit.id, packagingWeight: (weightNumber * 1000), weight, oldVal: this.selectedUnit.weight })
    },
    initializeCustomDimensions () {
      if (this.customDimensions.width === null && this.customDimensions.length === null && this.customDimensions.height === null) {
        this.customDimensions.width = this.selectedUnit.dimensions.width
        this.customDimensions.length = this.selectedUnit.dimensions.length
        this.customDimensions.height = this.selectedUnit.dimensions.height
      }
    },
    updateRecommendedDimensions (valuesArray) {
      let newDimensions = {}
      valuesArray.forEach((dimension) => {
        newDimensions[dimension.key] = dimension.value
      })
      this.customDimensions.width = isNaN(Number(newDimensions.width)) ? 0 : Number(newDimensions.width)
      this.customDimensions.length = isNaN(Number(newDimensions.length)) ? 0 : Number(newDimensions.length)
      this.customDimensions.height = isNaN(Number(newDimensions.height)) ? 0 : Number(newDimensions.height)
    },
    updateCustomDimensions (valuesArray) {
      let newDimensions = {}
      valuesArray.forEach((dimension) => {
        newDimensions[dimension.key] = dimension.value
      })
      let dimensions = {
        width: isNaN(Number(newDimensions.width)) ? 0 : Number(newDimensions.width),
        length: isNaN(Number(newDimensions.length)) ? 0 : Number(newDimensions.length),
        height: isNaN(Number(newDimensions.height)) ? 0 : Number(newDimensions.height)
      }
      this.setCustomDimensions({ id: this.selectedUnit.id, dimensions: dimensions, oldVal: this.selectedUnit.dimensions })
    },
    updateCustomName (value) {
      this.setCustomName({ id: this.selectedUnit.id, name: value, oldVal: this.selectedUnit.ref })
      // close()
    },
    changeStatus (value) {
      this.setCustomStatus({ id: this.selectedUnit.id, status: value.status, oldVal: this.selectedUnit.status })
      // close()
    },
    recommendEdit (close) {
      this.customDimensions = { ...this.customDimensions, ...this.isRecommended }
      let dimensions = {
        width: isNaN(Number(this.customDimensions.width)) ? 0 : Number(this.customDimensions.width),
        length: isNaN(Number(this.customDimensions.length)) ? 0 : Number(this.customDimensions.length),
        height: isNaN(Number(this.customDimensions.height)) ? 0 : Number(this.customDimensions.height)
      }
      this.setCustomDimensions({ id: this.selectedUnit.id, dimensions: dimensions })
      close()
    },
    ordersPlural(orders) {
      if (orders.length === 1) {
        return this.$i18n.t('orders.order')
      } else if (orders.length >= 2 && orders.length <= 4) {
        return this.$i18n.t('orders.orders')
      } else if (orders.length > 4) {
         return this.$i18n.t('orders.orders_second_plural')
      }
    },
    itemsPlural() {
       if (this.selectedUnit.items.length === 1) {
        return this.$i18n.t('drops.item')
      } else if (this.selectedUnit.items.length >= 2 && this.selectedUnit.items.length <= 4) {
        return this.$i18n.t('drops.items')
      } else if (this.selectedUnit.items.length > 4) {
         return this.$i18n.t('drops.items_second_plural')
      }
    }
  },
  computed: {
    computePackagingWeight: function () {
      return this.$options.filters.roundValueWeight(this.selectedUnit.packagingWeight, 0)
    },
    computeTotalWeight: function () {
      let totalWeight = 0
      if (this.selectedUnit.children.length > 0) {
        totalWeight = dropHelpers.calculateUnitWeight(this.selectedUnit)
        return { attribute: this.$i18n.t('drops.unit_weight_is'), value: this.$options.filters.roundValueWeight(totalWeight, 0) + ' kg', isLoading: false }
      } else {
        totalWeight = this.selectedUnit.weight
        // this.selectedUnit.items.forEach((item) => {
        //   totalWeight += item.weight
        // })
        return { attribute: this.$i18n.t('drops.unit_weight_is'), value: this.$options.filters.roundValueWeight(totalWeight, 0) + ' kg', isLoading: false }
      }
      return { attribute: null, value: null, isLoading: true }
    },
    computeTotalVolume: function () {
      let totalVolume = 0
      if (this.selectedUnit.children.length > 0) {
        this.selectedUnit.children.forEach((unit) => {
          totalVolume += (unit.dimensions.width * unit.dimensions.length * unit.dimensions.height) * 0.000001
        })
        return { attribute: this.$i18n.t('drops.volume_is') + ' ', value: this.$options.filters.roundValue(totalVolume, 1) + ' m³', isLoading: false }
      } else {
        totalVolume += (this.selectedUnit.dimensions.width * this.selectedUnit.dimensions.length * this.selectedUnit.dimensions.height) * 0.000001
        return { attribute: this.$i18n.t('drops.volume_is') + ' ', value: this.$options.filters.roundValue(totalVolume, 1) + ' m³', isLoading: false }
      }
      return { attribute: null, value: null, isLoading: true }
    },
    computeDimensions: function () {
      let totalDimensions = null
      if (this.selectedUnit) {
        totalDimensions = this.$options.filters.dimensionValue(this.selectedUnit.dimensions)
        return { attribute: this.$i18n.t('drops.dimensions_is') + ' ', value: totalDimensions, isLoading: false }
      }
      return { attribute: null, value: null, isLoading: true }
    },
    computeOrder: function () {
      let orders = []
      if (this.selectedUnit.children.length > 0) {
        let items = this.selectedUnit.children.length
        this.selectedUnit.children.forEach((unit) => {
          if (unit.items != null) {
            unit.items.forEach((item) => {
              if (orders.indexOf(item.orderRef) < 0) {
                orders.push(item.orderRef)
              }
            })
          }
        })
        return `<span style="margin-left: 0;" class="value">${orders.length} ${this.ordersPlural(orders)}</span><span class="attribute">${this.$i18n.t('drops.and')}</span><span class="value">${items} ${items > 1 ? this.$i18n.t('packages_type.boxes') + ' ' : this.$i18n.t('packages_type.box') + ' '}</span><span class="attribute"> ${this.$i18n.t('drops.in_total')}</span>`
      } else {
        if (this.selectedUnit.items != null) {
          this.selectedUnit.items.forEach((item) => {
            if (orders.indexOf(item.ref) < 0) {
              orders.push(item.ref)
            }
          })
        }
        return `<span style="margin-left: 0;" class="value">${orders.length} ${this.ordersPlural(orders)} </span><span class="attribute">${this.$i18n.t('drops.and')}</span><span class="value">${this.selectedUnit.items != null ?  + this.selectedUnit.items.length + ' ' + this.itemsPlural() : 0 + ' ' + this.$i18n.t('drops.items')}</span><span class="attribute"> ${this.$i18n.t('drops.in_total')}</span>`
      }
      return ''
    },
    isRecommended: function () {
      if (this.selectedUnit.children.length > 0) {
        let pallet = new Pallet(this.selectedUnit.children)
        const allRecomendations = pallet.calculateRecommendations().recomendedDims
        let flag = false
        if (this.customDimensions.width !== null) {
          Object.keys(allRecomendations).forEach((key) => {
            if (allRecomendations[key] !== this.customDimensions[key]) {
              flag = true
            }
          })
        } else {
          Object.keys(allRecomendations).forEach((key) => {
            if (allRecomendations[key] !== this.selectedUnit.dimensions[key]) {
              flag = true
            }
          })
        }
        if (flag) {
          return allRecomendations
        } else {
          return flag
        }
      } else {
        return false
      }
    },
    computeCustomName: function () {
      if (this.selectedUnit.ref !== undefined && this.selectedUnit.ref !== null) {
        return { text: this.selectedUnit.ref, value: this.selectedUnit.ref }
      } else {
        return { text: 'Add New', value: 'Add New' }
      }
    },
    computeStatus: function () {
      return this.$t('orders.' + this.selectedUnit.status)
    }
  },
  watch: {
    selectedUnit: {
      deep: true,
      handler (value) {
        this.customWeight = 0
        this.customDimensions.width = null
        this.customDimensions.length = null
        this.customDimensions.height = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
